import React, { Component } from 'react';
import './About.css';
import data from '../../data/About.js';

import Layout from '../../components/Layout/Layout';
import Icon from '../../components/Icon/Icon';
import Intro from '../../components/Intro/Intro';

import DidYouKnow from './DidYouKnow/DidYouKnow';
import Leadership from './Leadership/Leadership';
import Locations from './Locations/Locations';
import PeopleToKnow from './PeopleToKnow/PeopleToKnow';
import Processes from './Processes/Processes';
import Values from './Values/Values';

class About extends Component {
	render() {
		return (
			<Layout colors={ data.colors }>
				<div className="About">
					<Intro>
						<Icon icon="about.intro" title="Outer space cartoony people" />
						<div className="intro-title">
							<h1>About <span>Our</span> Company</h1>
							<p>
							So you've joined the IDSI family, but what do you know about IDSI and our history? IDSI has a long history of designing custom solutions to improve our customer's performance needs and helping people learn. The Performance Systems Group (PSG) creates digital training environments, web-based courses, skill gap and training-needs analyses, and mobile applications to meet customer needs.
							</p>
						</div>
						
						<div className="intro-sections">
							<div className="about-intro-section">
								<p className="sub-title">Mission</p>
								<p>Apply the latest research and innovation to position our customers for sustained, measurable success by optimizing human and organizational performance.</p>
							</div>
							
							<div className="about-intro-section">
								<p className="sub-title">Vision</p>
								<p>IDSI is a globally recognized leader and role model in human and organizational performance improvement.</p>
							</div>
						</div>
					</Intro>
					
					<DidYouKnow list={ data.didYouKnow } />
					<Processes docs={ data.docs } />
					<Values slides={ data.principles } />
					<Leadership people={ data.leadership } />
					<PeopleToKnow people={ data.people } />
					<Locations locations={ data.locations } />
				</div>
			</Layout>
		);
	}
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/About/About.js